import * as apiDomain from '@purecarslabs/signal-utils/env/apiDomain'
import isDevelopment from '@purecarslabs/signal-utils/env/isDevelopment'

const META_ENV = document.querySelector('meta[name=api-env]') as HTMLMetaElement

const DEV_API_DOMAIN =
  META_ENV?.getAttribute('content') === 'qa'
    ? apiDomain.QA_API_DOMAIN
    : apiDomain.DEFAULT_API_DOMAIN

declare global {
  interface Window {
    SignalDevAPIDomain: {
      reset: () => void
      setTo: (override?: string | { [domain: string]: string }) => void
    }
  }
}

// the code below will automatically sets the environment when running locally
if (isDevelopment()) {
  window.SignalDevAPIDomain.setTo(DEV_API_DOMAIN)
  window.addEventListener('unload', () => window.SignalDevAPIDomain.reset())
}
